import React from 'react';
const FormTitleCell = (props) => {
    var _a, _b, _c, _d;
    if (!props.colDef)
        return;
    const isCollapsed = (_b = (_a = props.data) === null || _a === void 0 ? void 0 : _a.isCollapsed) !== null && _b !== void 0 ? _b : false;
    const columnName = props.colDef.field;
    const formTitles = (_d = (_c = props.data) === null || _c === void 0 ? void 0 : _c.documents.map((metadata) => {
        var _a, _b;
        let formTitle = (_a = metadata.find(m => m.name === columnName)) === null || _a === void 0 ? void 0 : _a.value;
        if (!formTitle)
            formTitle = (_b = metadata.find(m => m.name === 'formName')) === null || _b === void 0 ? void 0 : _b.value;
        return typeof formTitle === 'string' ? formTitle : '';
    })) !== null && _d !== void 0 ? _d : [];
    if (isCollapsed) {
        const joinedTitle = formTitles === null || formTitles === void 0 ? void 0 : formTitles.filter(val => val && val.length).join(', ');
        if (!joinedTitle.length)
            return React.createElement(React.Fragment, null);
        return (React.createElement("span", { title: joinedTitle }, formTitles === null || formTitles === void 0 ? void 0 : formTitles.filter(val => val && val.length).join(', ')));
    }
    return (React.createElement("span", { className: 'form-title-wrapper' }, formTitles === null || formTitles === void 0 ? void 0 : formTitles.map((title) => (React.createElement("span", { className: 'form-title-expended', title: title },
        React.createElement("span", null, title),
        React.createElement("br", null))))));
};
export default FormTitleCell;
